module.exports = __webpack_public_path__ + "img/Share of voice Icon - white.33fb2d74.svg";